module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-technogym_tcm.4ac7ef04.jpg";